import { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../../utils/constant";
import { Delete, Pen } from "lucide-react";

const categoryOptions = [
    "Travel",
    "Food",
    "Office Supplies",
    "Maintenance",
    "Salary",
    "Marketing",
    "Utilities",
    "Other"
];

const ExpensesPage = () => {

    const companyId = localStorage.getItem("companyID");

    const [expenses, setExpenses] = useState([]);
    const [form, setForm] = useState({
        company_id: companyId || "",
        title: "",
        amount: "",
        category: "",
        expense_date: "",
        note: "",
    });

    const [editId, setEditId] = useState(null);
    console.log(companyId);
    // Fetch All Expenses
    const fetchExpenses = async () => {
        const res = await axios.get(`${API_URL}/company-expenses?company_id=${companyId}`);
        setExpenses(res.data);
    };

    useEffect(() => {
        fetchExpenses();
    }, []);

    // Handle Input Changes
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // Add or Update Expense
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (editId) {
            await axios.put(`${API_URL}/company-expenses/${editId}`, form);
        } else {
            await axios.post(`${API_URL}/company-expenses`, form);
        }

        fetchExpenses();

        setForm({
            company_id: companyId,
            title: "",
            amount: "",
            category: "",
            expense_date: "",
            note: "",
        });

        setEditId(null);
    };

    // Edit Button Action
    const handleEdit = (exp) => {
        setEditId(exp.id);
        setForm({
            company_id: exp.company_id,
            title: exp.title,
            amount: exp.amount,
            category: exp.category,
            expense_date: exp.expense_date,
            note: exp.note,
        });
    };

    // Delete Button Action
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this expense?")) return;
        await axios.delete(`${API_URL}/company-expenses/${id}`);
        fetchExpenses();
    };

    return (
        <>
            <div className="card" style={{ marginTop: "60px" }}>
                <div className="card-header">
                    <h3 className="text-primary">Company Expenses</h3>
                </div>
                <div className="card-header">
                    <form onSubmit={handleSubmit}>

                        {/* Hidden company_id */}
                        <input type="hidden" name="company_id" value={form.company_id} />

                        <div className="row justify-content-center align-item-center">

                            <div className="col-md-6">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Title
                                    </span>
                                    <input
                                        type="text"
                                        name="title"
                                        className="form-control"
                                        value={form.title}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Amount
                                    </span>
                                    <input
                                        type="number"
                                        step="0.01"
                                        name="amount"
                                        className="form-control"
                                        value={form.amount}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Category
                                    </span>
                                    <select
                                        name="category"
                                        className="form-control"
                                        value={form.category}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Category</option>
                                        {categoryOptions.map((cat) => (
                                            <option key={cat} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Date
                                    </span>
                                    <input
                                        type="date"
                                        name="expense_date"
                                        className="form-control"
                                        value={form.expense_date}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-md-7">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Note
                                    </span>
                                    <input
                                        type="text"
                                        name="note"
                                        className="form-control"
                                        value={form.note}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="col-md-2">
                                <button
                                    type="submit"
                                    className="btn btn-primary px-4 mt-3 w-100"
                                >
                                    {editId ? "Update Expense" : "Add Expense"}
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
                <div className="card-body">
                    <table className="table table-responsive table-striped">
                        <thead className="table-primary">
                            <tr>
                                <th>Title</th>
                                <th>Amount</th>
                                <th>Category</th>
                                <th>Date</th>
                                <th>Note</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {expenses.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="text-center">No expenses found</td>
                                </tr>
                            ) : (
                                expenses.map((exp) => (
                                    <tr key={exp.id}>
                                        <td>{exp.title}</td>
                                        <td>₹{exp.amount}</td>
                                        <td>{exp.category}</td>
                                        <td>{exp.expense_date}</td>
                                        <td>{exp.note}</td>
                                        <td>
                                            <button
                                                onClick={() => handleEdit(exp)}
                                                className="btn btn-warning btn-sm me-2"
                                            >
                                                <Pen/>
                                            </button>
                                            <button
                                                onClick={() => handleDelete(exp.id)}
                                                className="btn btn-danger btn-sm"
                                            >
                                                <Delete/>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>

                    </table>
                </div>
            </div>
        </>
    );
};

export default ExpensesPage;
